var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" Terms and Conditions ")]},proxy:true},{key:"main",fn:function(){return [_c('div',[_c('ContractComponent')],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }